import { Environment } from "src/libs/environment";

const isTest = process.env.NODE_ENV === "test";

export function OnlyDev() {
    return function decorator(
        target: any,
        propertyKey: string,
        descriptor: PropertyDescriptor
    ) {
        const isDevelopment =
            Environment.string("ENVIRONMENT") === "development";
        const { value: originalMethod } = descriptor;
        // eslint-disable-next-line no-param-reassign
        descriptor.value = function newMethod(...args: any[]) {
            if (isDevelopment && !isTest) {
                originalMethod.apply(this, args);
            }
            return null;
        };
    };
}
